import { render, staticRenderFns } from "./UploaderItemNew.vue?vue&type=template&id=610bc987&"
import script from "./UploaderItemNew.vue?vue&type=script&lang=js&"
export * from "./UploaderItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports